import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import KeycloakService from './keycloak/KeycloakService';
import RestService from './RestService';

/** Methods to interact with the REST, import, and vehicle services */

var UserManagementService = function () {
  function UserManagementService() {
    _classCallCheck(this, UserManagementService);

    this.rest = UserManagementService.initRestService();
    this.allClientsCache = null; // clients are responsible for different environment (test, staging prod), those are not users.
    this.rolesCache = null; // roles cache is used to keep available roles that can be used for current client.
  }

  _createClass(UserManagementService, [{
    key: 'loadAllUsers',


    // Load Users
    value: function loadAllUsers() {
      var _this = this;

      return new _Promise(function (resolve, reject) {
        _this.rest.getAllUsers().then(function (response) {
          resolve(response.data);
        }, function (error) {
          error.userManagementError = 'Failed to load users.';
          reject(error);
        });
      });
    }
  }, {
    key: 'loadUserByUsername',
    value: function loadUserByUsername(username) {
      var _this2 = this;

      return new _Promise(function (resolve, reject) {
        _this2.rest.getUsersByUsername(username).then(function (response) {
          resolve(response.data);
        }, function (error) {
          error.userManagementError = 'Failed to load user by username.';
          reject(error);
        });
      });
    }
  }, {
    key: 'getUsers',
    value: function getUsers(page, usersPerPage, search) {
      var _this3 = this;

      return new _Promise(function (resolve, reject) {
        _this3.rest.getUsers(page, usersPerPage, search).then(function (response) {
          resolve(response.data);
        }, function (error) {
          error.userManagementError = 'Failed to load users.';
          reject(error);
        });
      });
    }
  }, {
    key: 'getUserCount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rest.getUsersCount();

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserCount() {
        return _ref.apply(this, arguments);
      }

      return getUserCount;
    }()
  }, {
    key: 'getFilteredUserCount',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(maximumUserCountToGet, search) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.rest.getUsers(1, maximumUserCountToGet, search);

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', response.data.length);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getFilteredUserCount(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return getFilteredUserCount;
    }()
    // CREATE USER:

  }, {
    key: 'createUser',
    value: function createUser(userToBeCreated, defaultRoles) {
      var _this4 = this;

      var vm = this;
      return new _Promise(function (resolve, reject) {
        userToBeCreated.enabled = true;
        userToBeCreated.requiredActions = ['VERIFY_EMAIL', 'UPDATE_PASSWORD'];
        _this4.rest.addNewUser(userToBeCreated).then(function () {
          vm.getUserByUsername(userToBeCreated.username).then(function (currentUser) {
            vm.addRegularRolesToUser(currentUser, defaultRoles).then(function () {
              vm.sendEmailTo(currentUser).then(function () {
                resolve();
              }, function (error) {
                error.userManagementError = 'Unable to send e-mail to user.';
                reject(error);
              });
            }, function (error) {
              error.userManagementError = 'Unable to assign role to user.';
              reject(error);
            });
          }, function (error) {
            error.userManagementError = 'Cannot get user by username.';
            reject(error);
          });
        }, function (error) {
          error.userManagementError = 'Failed to create a user.';
          reject(error);
        });
      });
    }
  }, {
    key: 'removeRoleFromUser',
    value: function removeRoleFromUser(role, user) {
      var _this5 = this;

      var roles = [role];
      var vm = this;
      return new _Promise(function (resolve, reject) {
        vm.getTheClient().then(function (client) {
          _this5.rest.deleteUserRoles(user.id, client.id, roles).then(function (resp) {
            resolve(resp);
          }, function (error) {
            reject(error);
          });
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'addRoleToUser',
    value: function addRoleToUser(role, user) {
      var vm = this;
      return new _Promise(function (resolve, reject) {
        vm.getTheClient().then(function (client) {
          var rolesArray = [role];
          vm.rest.addUserRole(user.id, client.id, rolesArray).then(function (resp) {
            resolve(resp);
          }, function (error) {
            reject(error);
          });
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'addRegularRolesToUser',
    value: function addRegularRolesToUser(user, defaultRoles) {
      var vm = this;
      return new _Promise(function (resolve, reject) {
        vm.getTheClient().then(function (client) {
          vm.rest.addUserRole(user.id, client.id, defaultRoles).then(function (resp) {
            resolve(resp);
          }, function (error) {
            reject(error);
          });
        }, function (error) {
          reject(error);
        });
      });
    }

    // This method returns currentUser as a complete object from keycloak.

  }, {
    key: 'getUserByUsername',
    value: function getUserByUsername(username) {
      var vm = this;
      var currentUser = null;
      return new _Promise(function (resolve, reject) {
        vm.loadUserByUsername(username).then(function (users) {
          // We need to load the user as we does not have ID (it is not returned during its creation).
          if (users && users.length && users.length > 0) {
            currentUser = users.find(function (user) {
              return user.username === username;
            });
          }
          if (currentUser && currentUser.id) {
            // now we have an ID and we can grant role by user ID
            resolve(currentUser);
          } else {
            reject(new Error('Unable to add roles to user ' + username + ' the user ID was not found.'));
          }
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'getTheClient',
    value: function getTheClient() {
      var vm = this;
      return new _Promise(function (resolve, reject) {
        vm.getAllClients().then(function (clients) {
          // we need also the client ID for prod/staging/test - which is different than the client name
          var currentClient = null;
          var clientName = KeycloakService.getUsersClient();
          for (var c in clients) {
            if (clients[c].clientId === clientName) {
              currentClient = clients[c];
              break;
            }
          }
          if (currentClient != null) {
            resolve(currentClient);
          } else {
            reject(new Error('Keycloak client was not found.'));
          }
        });
      });
    }
  }, {
    key: 'sendEmailTo',
    value: function sendEmailTo(currentUser) {
      var vm = this;
      return new _Promise(function (resolve, reject) {
        vm.rest.sendVerificationEmail(currentUser.id).then(function (resp) {
          resolve(resp);
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'getAllClients',
    value: function getAllClients() {
      var vm = this;
      return new _Promise(function (resolve, reject) {
        if (vm.allClientsCache) {
          resolve(vm.allClientsCache);
        } else {
          vm.rest.getAllClients().then(function (response) {
            vm.allClientsCache = response.data;
            resolve(response.data);
          }, function (error) {
            reject(error);
          });
        }
      });
    }
  }, {
    key: 'getAllRoles',
    value: function getAllRoles() {
      var vm = this;
      return new _Promise(function (resolve, reject) {
        if (vm.rolesCache) {
          resolve(vm.rolesCache);
        } else {
          vm.getTheClient().then(function (client) {
            vm.rest.getAllRoles(client.id).then(function (response) {
              vm.rolesCache = response.data;
              resolve(response.data);
            }, function (error) {
              reject(error);
            });
          }, function (error) {
            reject(error);
          });
        }
      });
    }
  }, {
    key: 'getUserRoles',
    value: function getUserRoles(userId) {
      var _this6 = this;

      var vm = this;
      return new _Promise(function (resolve, reject) {
        vm.getTheClient().then(function (client) {
          _this6.rest.getUserRoles(userId, client.id).then(function (result) {
            resolve(result.data);
          }, function (error) {
            reject(error);
          });
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'deleteUserRoles',
    value: function deleteUserRoles(userId, clientId, rolesArray) {
      return this.rest.deleteUserRoles(userId, clientId, rolesArray);
    }

    // UPDATE USER:

  }, {
    key: 'editUser',
    value: function editUser(user) {
      return this.rest.editUser(user);
    }
  }, {
    key: 'deleteUser',


    // DELETE USER:
    value: function deleteUser(user) {
      return this.rest.deleteUser(user);
    }
  }], [{
    key: 'initRestService',
    value: function initRestService() {
      return new RestService();
    }
  }]);

  return UserManagementService;
}();

export default UserManagementService;


// WEBPACK FOOTER //
// ./src/service/UserManagementService.js